import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[Numberonly]'
})
export class NumberonlyDirective {

  //only allow whole number
  private clipboardSanitisationRegex: RegExp = new RegExp(/^(?:[0-9]+(?:\.[0-9]{0,2})?)?$/);

  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home'];

  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])

  onKeyDown(event: KeyboardEvent) {

    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const current: string = this.el.nativeElement.value;
    const next: string = current.concat(event.key);

    if (next && !String(next).match(this.clipboardSanitisationRegex)) {
      event.preventDefault();
    }


  }


}

@Directive({
  selector: '[numberOnlyMY]'
})
export class numberMobileNoDirective {

  private regex: RegExp = new RegExp(/\/(\d+)/ig);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home'];

  constructor(private el: ElementRef) {
  }
  @HostListener('keydown', ['$event'])

  onKeyDown(event: KeyboardEvent) {
    
    // Allow Backspace, tab, end, and home keys
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const current: string = this.el.nativeElement.value;
    var next: string = current.concat(event.key);

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }

  }
}
